import { useState } from "react";
import Icon,{ PlayCircleOutlined, LeftCircleOutlined, RightCircleOutlined,HighlightOutlined, StrikethroughOutlined } from '@ant-design/icons';
const Comment = (props) => (<Icon component={CustomIcons.getsvg("Comment")} {...props}/>);
import CustomIcons from "../../assets/CustomIcons";
const Shuffle = (props) => (<Icon component={CustomIcons.getsvg("Shuffle")} {...props}/>);
const Flip = (props) => (<Icon component={CustomIcons.getsvg("Flip")} {...props}/>);
const Bookmark = (props) => (<Icon component={CustomIcons.getsvg("Bookmark")} {...props}/>);
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', sans-serif; background: #fff; color: #1a1a1a; font-size: 14px; }

  /* NAV TABS */
  .nav-tabs { display: flex; gap: 0; border-bottom: 2px solid #e8e8e8; margin-bottom: 32px; }
  .nav-tab {
	padding: 10px 20px; font-size: 14px; font-weight: 500;
	color: #595959; cursor: pointer; border-bottom: 2px solid transparent;
	margin-bottom: -2px; transition: color .15s, border-color .15s;
  }
  .nav-tab:hover { color: #f1667c; }
  .nav-tab.active { color: #f1667c; border-bottom-color: #f1667c; }

  /* SECTION */
  .section { display: none; }
  .section.active { display: block; }

  h2 { font-size: 18px; font-weight: 700; color: #1a1a1a; margin-bottom: 6px; }
  .section-desc { font-size: 13.5px; color: #595959; line-height: 1.7; margin-bottom: 24px; }

  /* CARD */
  .card { background: #fff; border: 1px solid #e8e8e8; border-radius: 8px; margin-bottom: 14px; }
  .card-head { padding: 12px 18px; border-bottom: 1px solid #e8e8e8; font-size: 13.5px; font-weight: 600; color: #1a1a1a; }
  .card-body { padding: 14px 18px 18px; }

  /* LIST */
  .list { display: flex; flex-direction: column; gap: 6px; margin-top: 6px; }
  .list-item { display: flex; align-items: flex-start; gap: 9px; font-size: 13.5px; color: #595959; line-height: 1.6; }
  .dot { width: 6px; height: 6px; border-radius: 50%; background: #f1667c; flex-shrink: 0; margin-top: 7px; }
  .dot.sub { background: #ffb3c1; width: 5px; height: 5px; margin-top: 8px; }
  .list-item.sub { padding-left: 18px; }

  /* TAG */
  .tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
  .tag { background: #f1667c; color: #fff; border-radius: 4px; padding: 2px 10px; font-size: 12px; font-weight: 500; }
  .tag.outline { background: #fff0f3; color: #d44d63; border: 1px solid #ffb3c1; }

  /* ALERT */
  .alert { background: #fff0f3; border: 1px solid #ffb3c1; border-left: 3px solid #f1667c; border-radius: 6px; padding: 11px 14px; margin-top: 12px; font-size: 13px; color: #d44d63; line-height: 1.65; }
  .alert-yellow { background: #fffbe6; border: 1px solid #ffe58f; border-left: 3px solid #faad14; color: #7c5800; }

  /* STEPS */
  .steps { display: flex; flex-direction: column; gap: 10px; margin-top: 10px; }
  .step { display: flex; align-items: flex-start; gap: 10px; font-size: 13.5px; color: #595959; line-height: 1.6; }
  .step-num { width: 21px; height: 21px; border-radius: 50%; background: #f1667c; color: #fff; font-size: 11px; font-weight: 600; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }

  /* CTRL GRID */
  .ctrl-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(140px,1fr)); gap: 10px; margin-top: 12px; }
  .ctrl-card { background: #fafafa; border: 1px solid #e8e8e8; border-radius: 7px; padding: 12px 13px; }
.ctrl-label { display: flex; align-items: center; gap: 6px; font-size: 12.5px; font-weight: 600; color: #1a1a1a; margin-bottom: 3px; }

.ctrl-icon { font-size: 16px; display: inline-flex; align-items: center; }
  .ctrl-desc { font-size: 11.5px; color: #8c8c8c; line-height: 1.5; }

  .divider { border: none; border-top: 1px solid #e8e8e8; margin: 22px 0; }
  .sub-title { font-size: 14px; font-weight: 600; color: #1a1a1a; margin: 20px 0 10px; }
`;
const CTRL = [
	{ 
		label: "Play", 
		desc: "Begins the flashcard sequence",
		icon: <PlayCircleOutlined/> 
	},
	{ 
		label: "Shuffle", 
		desc: "Changes the display order",
		icon: <Shuffle className="icon-md"/>
	},
	{ 
		label: "Flip", 
		desc: "Shows answer side, then switches back",
		icon: <Flip className="icon-md"/>
	},
	{ 
		label: "Previous", 
		desc: "Moves to the previous flashcard",
		icon: <LeftCircleOutlined/>
	},
	{ 
		label: "Next", 
		desc: "Moves to the next flashcard",
		icon: <RightCircleOutlined/>
	},
	{ 
		label: "Mark", 
		desc: "Flags a flashcard for later study",
		icon: <Bookmark/>
	},
];
const ADDITIONALFEATURES = [
	{ 
		label: "Strikethrough", 
		desc: "Strike out options which you think are incorrect or irrelevant",
		icon: <StrikethroughOutlined/> 
	},
	{ 
		label: "Highlight", 
		desc: "Mark relevant words or sentences",
		icon: <HighlightOutlined/>
	},
	{ 
		label: "Notes", 
		desc: "Add your brief comment",
		icon: <Comment/>
	},
	{ 
		label: "Decrease Font", 
		desc: "Reduce the size of the text",
		icon: <span className="ans-display">A-</span>
	},
	{ 
		label: "Increase Font", 
		desc: "Enlarge the text to make it easier to read",
		icon: <span className="ans-display">A+</span>
	}
];
function Card({ title, children }) {
	return (
		<div className="card">
			<div className="card-head">{title}</div>
			<div className="card-body">{children}</div>
		</div>
	);
}
function List({ items, nested }) {
	return (
		<div className="list">
			{items.map((item, i) => (
				<div key={i} className={`list-item${nested ? " sub" : ""}`}>
					<div className={`dot${nested ? " sub" : ""}`}/>
					<span>{item}</span>
				</div>
			))}
		</div>
	);
}
export default function LearningTools() {
	const [tab, setTab] = useState("tutorial");
	return (
		<>
			<style dangerouslySetInnerHTML={{ __html: css }}/>
			<div className="container py-4">
				<Card title={"Learning Tools"} size="default" >
					<div>
						{/* NAV */}
						<div className="nav-tabs">
							<div className={`nav-tab${tab === "tutorial" ? " active" : ""}`} onClick={() => setTab("tutorial")}>Tutorials</div>
							<div className={`nav-tab${tab === "flashcards" ? " active" : ""}`} onClick={() => setTab("flashcards")}>Flashcards</div>
						</div>
						{/* TUTORIAL MODE */}
						<div className={`section${tab === "tutorial" ? " active" : ""}`}>
							<h2>Tutorials</h2>
							<p className="section-desc">Designed to support learning and practice in a low-pressure environment.</p>
							<Card title="Key Features">
								<List items={["No timer is displayed while using Tutorial Mode.", "Students can:"]}/>
								<List nested items={["Read a question", "Select an answer", "Submit the answer", "Immediately review the correct answer","Rate the difficulty of the questions","Read and understand the explanation given", "Proceed to the next question", "View your score at the end of the tutorial"]}/>
								<div className="alert">This allows students to learn from each question before continuing.</div>
							</Card>
							<Card title="Additional Features">
								<p style={{
									fontSize: 13.5,
									color: "#595959",
									lineHeight: 1.7,
									marginBottom: 4
								}}>Use these features while answering tutorials:</p>
								<div className="ctrl-grid">
									{ADDITIONALFEATURES.map(c => (
										<div key={c.label} className="ctrl-card">
											<div className="ctrl-label">
												<span className="ctrl-icon">{c.icon}</span>
												<span>{c.label}</span>
											</div>
											<div className="ctrl-desc">{c.desc}</div>
										</div>
									))}
								</div>
							</Card>
							<hr className="divider"/>
							<div className="sub-title">Tutorial Options</div>
							<p style={{ 
								fontSize: 13.5, 
								color: "#595959", 
								marginBottom: 14, 
								lineHeight: 1.7 
							}}>Students can attempt tutorials of different types.</p>
							<Card title="Categories">
								<p style={{ 
									fontSize: 13.5, 
									color: "#595959", 
									lineHeight: 1.7 
								}}>Students may select any of the following categories:</p>
								<div className="tags"><span style={{ backgroundColor: "#00AAB5" }} className="tag">FPP</span><span style={{ backgroundColor: "#A70050" }} className="tag">PIET</span><span style={{ backgroundColor: "#44A13F" }} className="tag">SAED</span></div>
								<List items={["Each tutorial contains 10 questions per category.","Two tutorials are available per category.", "Students may complete tutorials from all three categories.","Review the answered tutorial."]}/>
							</Card>
							<Card title="Topics">
								<p style={{ 
									fontSize: 13.5, 
									color: "#595959", 
									lineHeight: 1.7, 
									marginBottom: 6 
								}}>Students can choose specific topics from the list displayed.</p>
								<List items={["Questions are generated from the selected topic.", "Each tutorial contains 5 questions per topic.", "Students may take 1 tutorial from each topic.","Review the answered tutorial."]}/>
							</Card>
							<Card title="Custom tutorials">
								<p style={{ 
									fontSize: 13.5, 
									color: "#595959", 
									lineHeight: 1.7, 
									marginBottom: 6 
								}}>Students may create their own customized tutorials.</p>
								<List items={["Up to three custom tutorials can be created.", "Each tutorial includes 10 questions.", "Students may select the categories or topics from which the questions will be drawn.","Review the answered tutorial."]}/>
							</Card>
							<hr className="divider"/>
							<div className="sub-title">Other Features</div>
							<Card title="Marked for Later">
								<List items={["Students can mark questions during tests for later review.", "The Marked for Later tutorial displays only the questions previously flagged by the student."]}/>
							</Card>
							<Card title="Incorrect Answers">
								<List items={["Displays questions previously answered incorrectly during tests and tutorials.", "Once the student answers the question correctly, it will no longer appear in this section."]}/>
							</Card>
						</div>
						{/* FLASHCARDS */}
						<div className={`section${tab === "flashcards" ? " active" : ""}`}>
							<h2>Flashcards</h2>
							<p className="section-desc">Another method for reviewing test content — browse by chapter, topic, or review status.</p>
							<Card title="Flashcard Content">
								<p style={{ 
									fontSize: 13.5, 
									color: "#595959", 
									lineHeight: 1.7,
									marginBottom: 6 
								}}>Flashcards contain information from:</p>
								<List items={["The textbook", "The online practice tests database"]}/>
							</Card>
							<Card title="Selection Options">
								<p style={{ 
									fontSize: 13.5, 
									color: "#595959", 
									lineHeight: 1.7, 
									marginBottom: 6 
								}}>Students can choose to view:</p>
								<List items={["All flashcards in any chapter or any topic", "Flashcards starting with question or starting with answer or displaying both question and answer","Display:"]}/>
								<List nested items={["All flashcards (full set)", "Reviewed flashcards (cards previously viewed)", "Not Reviewed flashcards (new cards not yet viewed)", "Marked flashcards (cards flagged by the student)"]}/>
							</Card>
							<Card title="Display Options">
								<p style={{ 
									fontSize: 13.5, 
									color: "#595959", 
									lineHeight: 1.7, 
									marginBottom: 8 
								}}>Flashcards can be displayed in two formats:</p>
								<div className="tags">
									<span className="tag">Flashcard View</span>
									<span className="tag">List View</span>
								</div>
							</Card>
							<Card title="Navigation Controls">
								<p style={{ 
									fontSize: 13.5, 
									color: "#595959", 
									lineHeight: 1.7,
									marginBottom: 4 
								}}>Use these controls while studying:</p>
								<div className="ctrl-grid">
									{CTRL.map(c => (
										<div key={c.label} className="ctrl-card">
											<div className="ctrl-label">
												<span className="ctrl-icon">{c.icon}</span>
												<span>{c.label}</span>
											</div>
											<div className="ctrl-desc">{c.desc}</div>
										</div>
									))}
								</div>
							</Card>
						</div>
					</div>
				</Card>
			</div>
		</>
	);
}
